define.alias("shared/components/shared/post-tagging/badge", "settings/components/shared/post-tagging/badge");